import styled from '@emotion/styled';

const PushToRight = styled('div')({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
});

export default PushToRight;
